

// import React, { useState } from 'react';
// import { Outlet } from 'react-router-dom'; // ✅ Import this
// import Sidebar from '../components/common/Sidebar';
// import Navbar from '../components/common/Navbar';

// const AdminLayout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
//   const closeSidebar = () => setIsSidebarOpen(false);

//   return (
//     <div>
//       {/* Sidebar */}
//       <Sidebar role="admin" isOpen={isSidebarOpen} closeSidebar={closeSidebar} />

//       {/* Overlay */}
//       {isSidebarOpen && (
//         <div
//           className="overlay d-md-none"
//           onClick={closeSidebar}
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 1040,
//           }}
//         ></div>
//       )}

//       {/* Main Content */}
//       <div className={`content ${isSidebarOpen ? 'pe-none' : ''}`} style={{ marginLeft: '0px' }}>
//         <Navbar role="admin" toggleSidebar={toggleSidebar} />
//         <div className="p-4" style={{ marginTop: '56px' }}>
//           <Outlet /> {/* ✅ This is the fix */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;


import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import Navbar from '../components/common/Navbar';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sidebarWidth = 220;

  return (
    <div>
      {/* Sidebar */}
      <Sidebar role="admin" isOpen={isSidebarOpen} closeSidebar={closeSidebar} />

      {/* Overlay (for mobile) */}
      {isSidebarOpen && windowWidth < 768 && (
        <div
          className="overlay d-md-none"
          onClick={closeSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040,
          }}
        ></div>
      )}

      {/* Main Content */}
      <div
        className={`content ${isSidebarOpen ? 'pe-none' : ''}`}
        style={{
          marginLeft: windowWidth >= 768 ? `${sidebarWidth}px` : '0px',
          transition: 'margin-left 0.3s ease-in-out',
        }}
      >
        <Navbar role="admin" toggleSidebar={toggleSidebar} />
        <div className="p-4" style={{ marginTop: '56px' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;

